module.exports = __webpack_public_path__ + "static/media/Immobilier-Analyse-Vaud.87ba916b.jpg";